import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.eventPropertyName',
    label: 'Event property name',
    type: 'text',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ownershipStructure',
    label: 'Ownership structure',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  { name: 'dealDetails.3ASOwnership', label: '3AS Ownership (%)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.expectedAttendance',
    label: 'Expected attendance',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ticketRevenueTarget',
    label: 'Ticket revenue target ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.sponsorshipRevenueTarget',
    label: 'Sponsorship revenue target ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.productionBudget',
    label: 'Production budget ($)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.projectedMargin',
    label: 'Projected margin (%)',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
];

export const EventOwned = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'EVENT_OWNED';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);

        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName || stage);
                }
                break;
              case 'dealDetails.ownershipStructure':
                if (
                  dropdownsData.ownershipStructure &&
                  Array.isArray(dropdownsData.ownershipStructure)
                ) {
                  options = [...dropdownsData.ownershipStructure];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
